import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2, Clock } from 'lucide-react';
const CART_URL = 'https://www.kmsinrendirse.shop/cart/add?id=51999668764955&quantity=1';
function trackAddToCart() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart');
  }
}
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const includes = ['Acceso inmediato al programa completo', 'Descarga digital en PDF', 'Todos los bonos incluidos', 'Actualizaciones gratuitas de por vida'];
  return <section ref={ref} className="py-20 px-4 bg-gradient-to-b from-navy-light to-navy" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <motion.div className="bg-navy-light border-4 border-accent rounded-3xl p-8 md:p-12 shadow-2xl shadow-accent/20" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-82">
          {/* Urgency banner */}
          <motion.div className="bg-accent text-white px-6 py-3 rounded-xl mb-8 flex items-center justify-center gap-2" initial={{
          opacity: 0,
          y: -20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-83">
            <Clock size={24} data-id="element-84" />
            <span className="font-bold text-lg" data-id="element-85">
              Oferta limitada — Solo por tiempo limitado
            </span>
          </motion.div>

          <motion.h2 className="text-4xl md:text-5xl font-black text-center mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-86">
            Empezá tu transformación <span className="text-accent" data-id="element-87">HOY</span>
          </motion.h2>

          {/* Pricing */}
          <div className="text-center mb-8" data-id="element-88">
            <motion.div className="mb-4" initial={{
            opacity: 0
          }} animate={isInView ? {
            opacity: 1
          } : {}} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-89">
              <span className="text-2xl text-gray-400 line-through" data-id="element-90">
                Precio original: $30.000 ARS
              </span>
            </motion.div>
            <motion.div className="mb-2" initial={{
            opacity: 0,
            scale: 0.8
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            duration: 0.6,
            delay: 0.5
          }} data-id="element-91">
              <span className="text-6xl md:text-7xl font-black text-accent" data-id="element-92">
                $14.999
              </span>
              <span className="text-3xl text-gray-300 ml-2" data-id="element-93">ARS</span>
            </motion.div>
            <motion.p className="text-xl text-accent font-bold" initial={{
            opacity: 0
          }} animate={isInView ? {
            opacity: 1
          } : {}} transition={{
            duration: 0.6,
            delay: 0.6
          }} data-id="element-94">
              50% de descuento — Ahorrás $16.001
            </motion.p>
          </div>

          {/* What's included */}
          <motion.div className="bg-navy p-6 rounded-2xl mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.7
        }} data-id="element-95">
            <h3 className="text-2xl font-bold mb-4 text-center" data-id="element-96">Incluye:</h3>
            <div className="space-y-3" data-id="element-97">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-98">
                  <CheckCircle2 className="text-accent flex-shrink-0" size={24} data-id="element-99" />
                  <span className="text-lg text-gray-200" data-id="element-100">{item}</span>
                </div>)}
            </div>
          </motion.div>

          {/* CTA */}
          <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full bg-accent hover:bg-accent-dark text-white text-center px-12 py-6 rounded-2xl font-black text-2xl transition-all hover:scale-105 shadow-lg shadow-accent/40" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.8
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} data-id="element-101">
            QUIERO ACCESO AHORA
          </motion.a>

          <motion.p className="text-center text-gray-400 mt-6 text-sm" initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.9
        }} data-id="element-102">
            Acceso instantáneo después del pago
          </motion.p>
        </motion.div>
      </div>
    </section>;
}